import { render } from "./WorkSheet.vue?vue&type=template&id=f579fbf8"
import script from "./WorkSheet.vue?vue&type=script&lang=js"
export * from "./WorkSheet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__